export default class AdminSettings {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminSettingsEndpoint}/${id}`, payload)
  }
}
